module.exports = __webpack_public_path__ + "static/media/map-counties.159ade7a.svg";